module.exports = __webpack_public_path__ + "img/westminster-foundation-logo-long.1e579c4e.svg";